









import Editor from "@tinymce/tinymce-vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    Editor: Editor
  }
})
export default class HtmlEditorComponent extends Vue {
  @Prop() value?: string | null;
  @Prop({ default: "simple" }) mode!: string;
  key: string = "2i0mo6law1s5x7f5yeetc29w1n6o026zwlylbvwrgefark5s";
  current?: string | null = null;
  options: any = {};
  loaded: boolean = false;

  @Watch("current")
  onChange() {
    this.$emit("input", this.current);
  }

  created() {
    this.current = this.value;
    this.options = {
      menubar: false,
      plugins: ["advlist autolink lists link charmap anchor paste"],
      toolbar:
        "undo redo | formatselect | bold italic | \
        alignleft aligncenter alignright | \
        bullist numlist outdent indent"
    };
    this.loaded = true;
  }
}
